import { COORDINATE_VALIDATION, ADDRESS_VALIDATION } from './constants';

export const formatCoordinates = (latitude, longitude) => {
  if (!latitude || !longitude) return '';
  return `${Number(latitude).toFixed(5)}, ${Number(longitude).toFixed(5)}`;
};

export const parseCoordinates = coordString => {
  if (!coordString) return null;
  // Handle different formats of coordinates
  try {
    // Try to split by comma (standard format: "lat, lng")
    if (coordString.includes(',')) {
      const [lat, lng] = coordString.split(',').map(coord => {
        const num = parseFloat(coord.trim());
        return isNaN(num) ? NaN : Number(num.toFixed(5));
      });

      if (!isNaN(lat) && !isNaN(lng)) {
        return { latitude: lat, longitude: lng };
      }
    }

    // Try to extract numbers from the string (more flexible approach)
    const numbers = coordString.match(/-?\d+\.\d+/g);
    if (numbers && numbers.length >= 2) {
      const lat = parseFloat(numbers[0]);
      const lng = parseFloat(numbers[1]);

      if (!isNaN(lat) && !isNaN(lng)) {
        return { latitude: lat, longitude: lng };
      }
    }
    return null;
  } catch (error) {
    // Error parsing coordinates - return null to indicate invalid format
    return null;
  }
};

export const validateCoordinates = coordString => {
  if (!coordString) return COORDINATE_VALIDATION.REQUIRED;
  const coords = parseCoordinates(coordString);
  if (!coords) return COORDINATE_VALIDATION.INVALID_FORMAT;
  const { latitude, longitude } = coords;
  if (latitude < -90 || latitude > 90)
    return COORDINATE_VALIDATION.INVALID_LATITUDE;
  if (longitude < -180 || longitude > 180)
    return COORDINATE_VALIDATION.INVALID_LONGITUDE;
  return undefined;
};

export const REQUIRED_ERROR = 'This field is required';

export const validateForm = values => {
  const errors = {};

  // Validate coordinates
  const coordError = validateCoordinates(values.pickup_coordinates);
  if (coordError) {
    errors.pickup_coordinates = coordError;
  }

  // Required fields
  if (!values.pickup_location) {
    errors.pickup_location = ADDRESS_VALIDATION.REQUIRED;
  }

  if (!values.ground_contact) {
    errors.ground_contact = REQUIRED_ERROR;
  }

  if (!values.patient_info) {
    errors.patient_info = REQUIRED_ERROR;
  }

  if (!values.request_reason || values.request_reason === 'Select') {
    errors.request_reason = REQUIRED_ERROR;
  }

  if (!values.air_service_declined) {
    errors.air_service_declined = REQUIRED_ERROR;
  }

  if (!values.air_service_responding) {
    errors.air_service_responding = REQUIRED_ERROR;
  }

  if (!values.multiple_units_requested) {
    errors.multiple_units_requested = REQUIRED_ERROR;
  }

  if (!values.launch_type) {
    errors.launch_type = REQUIRED_ERROR;
  }

  return errors;
};
